import React from 'react';

// 개인정보처리방침. Shown in the sign-up layer and at /Privacy (store listing link).
// Fill in before release: the address users can write to about their data.
const CONTACT_EMAIL = '';
const COMPANY = '코드모도(codemodo)';
const OFFICER = '윤석모';

const Policy02 = () => (
  <div id="policy">
    <h3>두벅 영워드 개인정보처리방침</h3>
    <p>{COMPANY}(이하 "회사")는 두벅 영워드를 운영하며, 이용자의 개인정보를 아래와 같이 처리합니다.</p>

    <div className='area'>
      <strong className='title'>1. 수집하는 개인정보</strong>
      <p>
        · 이메일 가입: 이메일, 이름(닉네임), 비밀번호(암호화하여 저장)<br />
        · 카카오 로그인: 카카오 회원번호, 닉네임, 이메일(인증된 경우)<br />
        · Apple 로그인: Apple 사용자 식별자, 이메일(또는 Apple이 제공하는 가림 이메일), 이름(제공한 경우)<br />
        · Google 로그인: Google 사용자 식별자, 이름, 이메일(인증된 경우)<br />
        · 가입 없이 체험: 개인을 알아볼 수 없는 임시 계정 식별자만 만듭니다. 이후 가입하면 체험 기록이 가입한 계정으로 옮겨지고 임시 계정은 삭제됩니다.<br />
        · 서비스 이용 중 생성: 학습 기록(출석일, 레슨·복습 결과, 단어별 학습 상태, 시험 결과), 소리함에 남긴 의견
      </p>
    </div>

    <div className='area'>
      <strong className='title'>2. 이용 목적</strong>
      <p>회원 식별과 로그인, 학습 진도·복습 일정 관리, 학습 통계 제공, 비밀번호 찾기 메일 발송, 문의 응대와 서비스 개선에만 이용합니다. 광고나 마케팅에는 이용하지 않습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>3. 음성 정보</strong>
      <p>'따라 말하기'에서 마이크를 누르면 음성이 휴대폰 운영체제(Apple 또는 Google)의 음성 인식 기능으로 처리되며, 인식된 문장만 정답 확인에 쓰입니다. 두벅 영워드 서버는 음성을 받거나 저장하지 않습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>4. 보관 기간과 파기</strong>
      <p>개인정보는 회원 탈퇴 시까지 보관하며, 탈퇴하면 즉시 삭제합니다. 소리함 의견은 작성자 정보를 지운 뒤 서비스 개선 자료로만 남습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>5. 처리 위탁과 외부 서비스</strong>
      <p>
        · Oracle Cloud: 서버와 데이터베이스 운영<br />
        · Cloudflare, Inc.: 암호화된 통신 전달과 보안(전송 과정에서 해외 네트워크를 거칠 수 있음)<br />
        · 카카오, Google, Apple: 이용자가 선택한 경우의 로그인 인증<br />
        · Google(Gmail): 비밀번호 찾기 메일 발송<br />
        개인정보를 위 목적 외의 제3자에게 제공하거나 판매하지 않습니다.
      </p>
    </div>

    <div className='area'>
      <strong className='title'>6. 이용자의 권리</strong>
      <p>이용자는 마이페이지에서 자신의 정보를 확인·수정할 수 있고, '회원 탈퇴'로 언제든지 모든 정보를 삭제할 수 있습니다. 만 14세 미만은 가입할 수 없습니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>7. 안전성 확보 조치</strong>
      <p>모든 통신은 HTTPS로 암호화하고, 비밀번호는 복호화할 수 없는 방식(bcrypt)으로 저장하며, 데이터베이스 접근을 운영자로 제한합니다.</p>
    </div>

    <div className='area'>
      <strong className='title'>8. 개인정보 보호책임자와 문의</strong>
      <p>
        · 개인정보처리자: {COMPANY}<br />
        · 개인정보 보호책임자: {OFFICER}{CONTACT_EMAIL && <> ({CONTACT_EMAIL})</>}<br />
        개인정보 관련 문의·열람·정정·삭제 요청은 앱의 '두벅이 소리함'{CONTACT_EMAIL && <> 또는 위 이메일</>}로 보내 주세요.
      </p>
    </div>

    <div className='area'>
      <strong className='title'>부칙</strong>
      <p>이 방침은 2026년 10월 21일부터 시행합니다.</p>
    </div>
  </div>
);

export default Policy02;
